import styles from './index.module.css'
import { Tabs, Tab } from '@appkit4/react-components/tabs'
import classnames from 'classnames'

export const View = ({ itemList, className, ...props }) => {
    return (
        <Tabs className={classnames(styles.default, className)} {...props}>
            {itemList.map(({ label, value, children, ...props }) => {
                return (
                    <Tab key={value} label={label} value={value} {...props}>
                        {children}
                    </Tab>
                )
            })}
        </Tabs>
    )
}
